<template>

        <div class="wrap inputAreaWrap">
            <div class="wrappedContent inputArea">

                <div class="narrowHeader row">
                    <div class="col-7">
                        <h2>配偶者について</h2>
                    </div>

                    <div class="col-5 text-right">
                        <img src="@/assets/img/input/indicator_2.png" class="indicatorImg" alt="">
                    </div>
                </div>




                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label for="">配偶者</label>
                    </div>
                    <div class="col-8 col-lg-7 ">
                        <div class="btnBox">
                            <div class="btn" :class="{ active: haiguusha.ari == 1 }" @click="haiguusha.ari = 1">いる</div>
                            <div class="btn" :class="{ active: haiguusha.ari == 0 }" @click="haiguusha.ari = 0">いない</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label for="">年齢</label>
                    </div>
                    <div class="col-8 col-lg-7 ">
                        <select v-model="haiguusha.age" :disabled="!haiguusha.ari">
                            <option :value="value" v-for="(value,index) in selectOptionsData(18, 70)" :key="index">{{value}}</option>
                        </select>
                        <span class="unit-label">歳</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label for="">職業<span style="font-size: 75%; vertical-align: super;">※</span></label>
                    </div>
                    <div class="col-8 col-lg-7 ">
                        <div class="btnBox">
                            <button class="btn" :class="{ active: haiguusha.shokugyou == 1 }" @click="haiguusha.shokugyou = 1" :disabled="!haiguusha.ari">会社員</button>
                            <button class="btn" :class="{ active: haiguusha.shokugyou == 2 }" @click="haiguusha.shokugyou = 2" :disabled="!haiguusha.ari">公務員</button>
                        </div>
                        <div class="btnBox">
                            <button class="btn" :class="{ active: haiguusha.shokugyou == 3 }" @click="haiguusha.shokugyou = 3" :disabled="!haiguusha.ari">自営業</button>
                            <button class="btn" :class="{ active: haiguusha.shokugyou == 4 }" @click="haiguusha.shokugyou = 4" :disabled="!haiguusha.ari">専業主婦/主夫</button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label for="">手取り月収</label>
                    </div>
                    <div class="col-8 col-lg-7 d-flex align-items-center">
                        <select v-model="haiguusha.geshuu" :disabled="!haiguusha.ari">
                            <option :value="value" v-for="(value,index) in selectOptionsData(1, 100)" :key="index">{{value}}</option>
                        </select>
                        <span class="unit-label">万円</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label>手取りボーナス（年合計）</label>
                    </div>
                    <div class="col-8 col-lg-7 d-flex align-items-center">
                        <input type="text" inputmode="numeric" pattern="\d*" v-model="haiguusha.bonus" @change="haiguusha.bonus = zenHan($event)" :disabled="!haiguusha.ari">
                        <span class="unit-label">万円</span>
                        <div class="input-description">手取り年収<br>{{ nenshu }}万円</div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-4 col-lg-5 text-right">
                        <label for="">退職の年齢</label>
                    </div>
                    <div class="col-8 col-lg-7 ">
                        <select v-model="haiguusha.retirementAge" :disabled="!haiguusha.ari">
                            <option :value="data.value" v-for="(data,index) in selectOriginalOptionsData(haiguusha.age*1, 90, 1, [{value:0, text:'退職予定なし'}])" :key="index">{{data.text}}</option>
                        </select>
                        <span v-if="haiguusha.retirementAge !== 0" class="unit-label">歳</span>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-7 col-lg-4 offset-4 offset-lg-5 detail-notice" style="text-indent: -0.5rem;">
                        ※パート・アルバイトをされている方は専業主婦/主夫を選択し、月収を入力してください。
                        <br>
                    </div>
                </div>



                <div class="row btn-next-row">
                    <div class="col text-center">
                        <router-link to="/input3" class="btn btn-outline-primary btn-next">次に進む</router-link>
                    </div>
                </div>

                <div class="row btn-prev-row">
                    <div class="col text-center">
                        <router-link to="/" class="btn btn-outline-primary btn-prev">戻る</router-link>
                    </div>
                </div>


            </div>

        </div>


</template>

<script>
import Calc from "@/store/calcUtil.js"
export default {
    name: "input2.vue",
    data() {
        return {
            haiguusha:{
                ari:null,
                age:null,
                shokugyou:null,
                geshuu:null,
                bonus: null,
                retirementAge:null,
            },
        }
    },
    computed: {
        nenshu() {
            let nenshu = this.haiguusha.geshuu * 12 + this.haiguusha.bonus*1;
            if (isNaN(nenshu)) {
                return 0;
            }
            return nenshu;
        }
    },
    methods: {
        setInputsData() {
            this.$store.commit('setHaiguusha', this.haiguusha);
        },
        selectOptionsData(start, end, interval=1) {
            let options = [''];
            // console.log(interval);

            for (let i = start; i <= end; i = i+interval) {
                options.push(i);
            }

            return options;
        },
        selectOriginalOptionsData(start, end, interval=1, originals=[]) {
            let options = [{value:'', text:''}];

            if (originals.length){
                originals.forEach(obj => {
                    options.push(obj);
                });
            }

            for (let i = start; i <= end; i = i+interval) {
                options.push({value:i, text:i});
            }

            return options;
        },
        zenHan(e) {
            return Calc.han2Zen(e.target.value)
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.haiguusha = Object.assign({}, vm.haiguusha, vm.$store.state.haiguusha);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.setInputsData();
        next();
    }
}
</script>

<style lang="scss" >



</style>
